import { createNamespacedHelpers } from 'vuex';
import BaseStore from '@/store';
import actions from './unknownItems.actions.js';
import getters from './unknownItems.getters.js';
import mutations from './unknownItems.mutations.js';
import state from './unknownItems.state.js';

BaseStore.registerModule('unknownItems', {
	namespaced: true,
	state,
	actions,
	getters,
	mutations
});
export default BaseStore;

let { mapState, mapGetters, mapMutations, mapActions } = createNamespacedHelpers('unknownItems');

export {
	mapState,
	mapGetters,
	mapMutations,
	mapActions
};
